import React from 'react';

const ParkingList = ({ data, onSelect }) => {
  const statusColor = (status) => {
    if (status == 1) {
      return 'bg-cyan-500';
    }

    if (status == 0) {
      return 'bg-accent';
    }

    if (status == 2) {
      return 'bg-yellow-800';
    }

    if (status == 3) {
      return 'bg-red-500';
    }

    if (status == 4) {
      return 'bg-green-500';
    }
  }

  const statusDisplay = (status) => {
    if (status == 1) {
      return (
        <div className='text-sm md:text-lg font-bold'>Open</div>
      )
    }

    if (status == 0) {
      return (
        <div className='text-sm md:text-lg font-bold'>Closed</div>
      )
    }

    if (status == 2) {
      return (
        <div className='text-sm md:text-lg leading-3 font-bold'>Requested</div>
      )
    }

    if (status == 3) {
      return (
        <div className='text-sm md:text-lg leading-3 font-bold'>Make Ready</div>
      )
    }

    if (status == 4) {
      return (
        <div className='text-sm md:text-lg leading-3 font-bold'>Car Ready</div>
      )
    }
  }

  return (
    <div className='grid grid-cols-4 md:gap-1 xl:gap-2 lg:gap-5 max-w-6xl mx-auto'>
      {data.map((parkingItem) => (
        <div 
          key={parkingItem.id} 
          className={statusColor(parkingItem.status) + ' m-1 md:m-2 rounded-lg flex items-center justify-center cursor-pointer'}
          onClick={() => onSelect(parkingItem.id)}
        >
          <div className='p-4 text-center w-100 text-secondary'>
            <h2 className='text-sm md:text-2xl md:mb-3 mb-1 mt-0'>
              {parkingItem.key_tag}
            </h2>
            <h3 className='text-sm md:text-xl md:mb-3 mb-2'>
              {parkingItem.vehicle_plate}
            </h3>
            <div className='text-xs md:text-sm font-bold text-secondary'>
              {parkingItem.parking_time || 'N/A'}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ParkingList;
